import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Text } from "@gusarov-studio/rubik-ui";
import { routesMap } from "../../../router/routesMap";
import { CenteredColumnLayout } from "../../../common/components/Layout";
import { supabase } from "../../../supabase";
import { persistor } from "../../../store";
import { resourcesApi } from "../../../modules/resources";
import { promptApi } from "../../../modules/prompts/api";
import { usersApi } from "../../../modules/users";

function LogoutScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    async function handleLogout() {
      try {
        // 1. Sign out with Supabase first
        await supabase.auth.signOut();

        // 2. Reset RTK Query API cache
        dispatch(resourcesApi.util.resetApiState());
        dispatch(promptApi.util.resetApiState());
        dispatch(usersApi.util.resetApiState());

        // 3. Purge persisted Redux state
        await persistor.purge();

        // 4. Navigate to login screen
        navigate(routesMap.login.url());
      } catch (e) {
        console.error(e);
      }
    }

    handleLogout();
  }, [navigate, dispatch]);

  return (
    <CenteredColumnLayout>
      <Text
        align="center"
        block
        size="36"
        weight="600"
      >
        You have logged out
      </Text>
    </CenteredColumnLayout>
  );
}

export { LogoutScreen };
